<mat-card appearance="outlined">
  <h4 class="text-center">Sign</h4>
  <mat-card-content>
    <div class="row d-flex gap-3 flex-row justify-content-center align-items-center">
      <ng-container>
        <div (window:resize)="onResize()" class="signature-wraps" [class.hidden]="prevSignatureImg">
          <signature-pad [options]="signaturePadOptions" #signaturePad
                         (drawEnd)="drawComplete()"></signature-pad>
        </div>
      </ng-container>
      <ng-container *ngIf="prevSignatureImg">
        <div class="signature-area" data-toggle="modal" data-target="#sign">
          <div>
            <img class="img-fluid" src="{{this.storageUrl  +  prevSignatureImg}}" alt="">
          </div>
        </div>
      </ng-container>
    </div>
  </mat-card-content>
  <mat-card-actions class="d-flex flex-row justify-content-end gap-3" *ngIf="type != 'readonly'">
    <button mat-raised-button color="primary" type="button" (click)="clear(signaturePad)">
      {{(prevSignatureImg ? "USERS.editor.edit_signature" : "USERS.editor.clear_signature") | translate}}
    </button>
    <button mat-raised-button color="primary" type="button" data-dismiss="modal" (click)="saveSignature()"
            class="save-btn">
      {{"USERS.editor.save_signature" | translate}}
    </button>
  </mat-card-actions>
</mat-card>
